import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CommonState } from '@shared/models/common/common-state';
import { DossierRemboursement } from '@features/mes-remboursements/models/dossier-remboursement.model';
import { MesRemboursementsActions } from '@features/mes-remboursements/store/remboursements/mes-remboursements.actions';

export const MES_REMBOURSEMENT_FEATURE_KEY = 'mesRemboursements';

export interface DossierRemboursementState extends EntityState<DossierRemboursement>, CommonState {
  totalElements: number;
  exportLoading: boolean;
}

export const entiteAdapter: EntityAdapter<DossierRemboursement> = createEntityAdapter<DossierRemboursement>({
  selectId: (dossier: DossierRemboursement) => dossier.identifiantDossier,
});

const initialState: DossierRemboursementState = entiteAdapter.getInitialState({
  totalElements: 0,
  loading: true,
  errorMessage: null,
  exportLoading: false
});

export const mesRemboursementsReducers = createReducer(
  initialState,
  on(MesRemboursementsActions.getDossiersBySearchCriteriaSuccess, (state, { dossiers }) => {
    
    return entiteAdapter.setAll(dossiers.items, {
      ...state,
      loading: false,
      errorMessage: null,
      totalElements: dossiers.totalElements,
    });
  }),
  on(MesRemboursementsActions.getDossiersBySearchCriteriaFailure, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
  })),
  on(MesRemboursementsActions.addRemboursementToList, (state, { dossier }) =>
    entiteAdapter.addOne(dossier, state),
  ),
  on(MesRemboursementsActions.updateRemboursementList, (state, { dossier }) =>
    entiteAdapter.updateOne(dossier, state),
  ),
  on(MesRemboursementsActions.deleteDossier, (state, { idDossier }) =>
    entiteAdapter.removeOne(idDossier, state),
  ),
  on(MesRemboursementsActions.updateLoading, (state, { isLoading }) => ({
    ...state,
    loading: isLoading
  })),
  on(MesRemboursementsActions.updateExportLoading, (state, { isLoading }) => ({
    ...state,
    exportLoading: isLoading
  }))
);

export const reducer = (
  state: DossierRemboursementState | undefined,
  action: Action,
): DossierRemboursementState => mesRemboursementsReducers(state, action);
